import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import VoiceModal from './Modal';
import MicroPhone from './Microphone';
import MicrophoneV2 from './MicrophoneV2';
import { VoiceSearchProps } from 'types/voiceSearch';
import { State } from 'store/types';

const VoiceSearch = ({
  handleVoiceSearch,
  showVoiceModal = false,
  toggleVoiceModal,
  showVoiceIcon,
}: VoiceSearchProps) => {
  const [showModal, setShowModal] = useState(showVoiceModal);
  const isNewSearchEnabled = useSelector(
    (state: State) => state.remoteConfig.switches.isNewSearchBarEnabled
  );
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    toggleVoiceModal(false);
  };

  const voiceSearchCallback = (param: string) => {
    closeModal();
    handleVoiceSearch(param);
  };
  return (
    <>
      {showVoiceIcon && isNewSearchEnabled ? (
        <MicrophoneV2 handleMicrophone={openModal} />
      ) : (
        <MicroPhone handleMicrophone={openModal} />
      )}
      {showModal && (
        <VoiceModal
          handleClose={closeModal}
          handleVoiceSearch={voiceSearchCallback}
        />
      )}
    </>
  );
};

export default VoiceSearch;
